import React from "react";
import {Table} from "reactstrap";
import Order from "../../../../components/fields/Order";
import LenderTitle from "../../../../components/fields/LenderTitle";
import Product from "../../../../components/fields/Product";
import OrderStatus from "../../../../components/status/OrderStatus";

export const SameIntegration = ({integrations, orderId}) => {
    return <>
        {integrations.length > 0 &&
            <div className="table-responsive">
                <Table>
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Title</th>
                        <th>Lender</th>
                        <th>Product</th>
                        <th>Price</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {integrations.map((order, index) => {
                        return (
                            <tr key={order.id}>
                                <td>{order.id}</td>
                                <td>
                                    <Order order={order} tags={true}/>
                                </td>
                                <td>
                                    <LenderTitle
                                        title={order.lender.title}
                                        id={order.lender.id}
                                    />
                                </td>
                                <td>
                                    <Product product={order.product}/>
                                </td>
                                <td>
                                    <strong>
                                        {order?.price?.length > 0 && <>${order.price}</>}
                                    </strong>
                                </td>
                                <td>
                                    <OrderStatus status={order.status} id={order.id}/>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </Table>
            </div>
        }
    </>
}
